import request from '@/utils/request'
import qs from 'qs'

let index = {
  //获取3D相关材质信息
  async loadUser3DInfo() {
    return request({
      url: 'app/getUser3DInfo',
      method: 'POST',
      data: qs.stringify({
        userId: 8
      })
    })
  },
  //获取款式信息
  async loadDesignInfo(desNo) {
    return request({
      url: 'app/designLayerInfo',
      method: 'POST',
      data: qs.stringify({
        designId:desNo
      })
    })
  },
  //获取款式搭配列表
  async loadDesignCollocations(desNo) {
    return request({
      url: 'app/findCollocationsByDesignId',
      method: 'POST',
      data: qs.stringify({
        designId:desNo
      })
    })
  }
}

export default index;



// WEBPACK FOOTER //
// ./src/api/index.js